// extracted by mini-css-extract-plugin
module.exports = {"emptyBox":"EmptyBox_emptyBox__xnHkk","title":"EmptyBox_title__2zumP","description":"EmptyBox_description__1qWHf","secondaryDescription":"EmptyBox_secondaryDescription__2Popi"};